import React, { useState, useEffect } from 'react';
import { Empty, Button, Pagination, Checkbox, Space, Dropdown, Menu, Input, Divider, Badge, Select } from 'antd';
import {
  CaretDownOutlined,
  CaretUpOutlined,
} from '@ant-design/icons';
import {Collapse} from 'react-collapse';
import './style';
import { Collpase } from '..';

export default React.forwardRef((props, ref) => {
  const { title, children } = props;

  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className="collapse-container">
      < Divider orientation="left" >
        <Button  onClick={()=>setCollapsed(!collapsed)} style={{ padding: 0, margin: 0 }} type="link" size="small">{title}{collapsed ? <CaretUpOutlined /> : <CaretDownOutlined />}</Button>
      </Divider >
      <Collapse isOpened={!collapsed}>
        {children}
        </Collapse>
    </div>
  );
});
